import { ArrowDownRight, ArrowUpRight, BookOpen, Check } from "lucide-react";
import { useEffect, useState } from "react";
import { imagery } from "@/content";
import { Reveal } from "@/components/Reveal";

export default function HeroSection({ onPurchase }) {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const update = () => setScrollY(window.scrollY);
    window.addEventListener("scroll", update, { passive: true });
    return () => window.removeEventListener("scroll", update);
  }, []);

  const showChapters = () => document.getElementById("capitulos")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section className="hero-section" id="topo" data-testid="hero-section">
      <div className="section-shell hero-grid">
        <div className="hero-copy">
          <Reveal>
            <p className="eyebrow">GUIA DE 30 PÁGINAS · FÉ, HÁBITOS E VERDADE</p>
            <h1>Volte a ser dono do seu próximo passo.</h1>
            <p className="hero-lead">Um caminho direto e compassivo para romper o ciclo das bets, reorganizar sua rotina e reencontrar paz em Jesus — sem culpar você, sem vender milagres.</p>
            <div className="hero-actions">
              <button className="button button-primary" type="button" onClick={onPurchase} data-testid="hero-primary-cta-button">Começar por R$ 29,99 <ArrowUpRight size={17} /></button>
              <button className="text-button" type="button" onClick={showChapters} data-testid="hero-secondary-preview-button">Ver os 7 capítulos <ArrowDownRight size={17} /></button>
            </div>
            <div className="hero-proof" data-testid="hero-trust-note">
              <span><Check size={14} /> leitura prática</span>
              <span><Check size={14} /> acesso após aprovação</span>
              <span><Check size={14} /> conteúdo transparente</span>
            </div>
          </Reveal>
        </div>
        <Reveal className="hero-visual" delay={100}>
          <figure className="hero-photo-frame">
            <img src={imagery.hero} alt="Pessoa serena em uma manhã clara, representando um novo começo" style={{ transform: `translateY(${Math.min(scrollY * 0.035, 18)}px) scale(1.04)` }} />
            <div className="photo-stamp"><BookOpen size={15} /><span>UM GUIA PARA<br /><strong>RECOMEÇAR</strong></span></div>
          </figure>
          <figcaption className="hero-caption"><span>01 / RECOMEÇO</span><span>O futuro não precisa repetir o último impulso.</span></figcaption>
        </Reveal>
      </div>
    </section>
  );
}
